'use client';

import type { HTMLAttributes } from 'react';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useIntl } from 'react-intl';
import { selectedQuantity } from '../atoms';
import {
  QuantitySelection,
  type QuantitySelectionProps,
} from '../QuantitySelection/QuantitySelection.client';

export type QuantitySelectionAtomizedProps = HTMLAttributes<HTMLDivElement> & {
  quantitySelectionProps?: QuantitySelectionProps;
  hideLabel?: boolean;
};

export const QuantitySelectionAtomized = ({
  hideLabel = false,
  quantitySelectionProps,
  ...props
}: QuantitySelectionAtomizedProps) => {
  const [atomQuantity, setAtomQuantity] = useAtom(selectedQuantity);
  const { formatMessage } = useIntl();

  // Quantity will be updated, if user uses miniDV
  useEffect(() => {
    if (quantitySelectionProps?.quantity) {
      setAtomQuantity(quantitySelectionProps.quantity);
    }
  }, [quantitySelectionProps?.quantity, setAtomQuantity]);

  return (
    <article {...props}>
      {!hideLabel && (
        <header className="text-size-body-sm mb-1 leading-2.5 font-normal select-none">
          {formatMessage({
            id: 'quantitySelection.label',
            defaultMessage: 'Anzahl',
          })}
        </header>
      )}
      <QuantitySelection
        {...quantitySelectionProps}
        onUpdate={(value) => {
          setAtomQuantity(value);
        }}
        quantity={atomQuantity}
      />
    </article>
  );
};
